import { render } from "./CompanyTile.vue?vue&type=template&id=18a93f43&scoped=true"
import script from "./CompanyTile.vue?vue&type=script&lang=js"
export * from "./CompanyTile.vue?vue&type=script&lang=js"

import "./CompanyTile.vue?vue&type=style&index=0&id=18a93f43&scoped=true&lang=css"

import exportComponent from "/Users/felix/dev/projects/protfolio/schillerando-demo/schillerando-demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18a93f43"]])

export default __exports__